<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      :custom-on-row-click="goto"
      :model="model"
      :required-date-value="$parent.dateRange"
      :use-default-action="false"
      entity-name="EmployeeStatistics"
      icon="mdi-cards"
    >
      <template #primaryButton>
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="downloadExcel"
        >
          <div
            class="d-flex align-center"
          >
            <v-icon
              left
            >
              mdi-file
            </v-icon>
            <template>
              <div
                class="text-truncate"
                style="max-width: 80px !important;"
              >
                {{ $t('download') }}Excel
              </div>
            </template>
          </div>
        </v-btn>
      </template>
    </ik-data-table>
    <v-dialog
      v-model="showDetailInfo"
      max-width="800px"
    >
      <v-card class="pa-4">
        <loading-provider :loading="dialogLoading">
          <div class="d-flex align-center justify-center">
            <page-sub-header>
              {{ currentStaffInfo?.servantName ?? '' }}
            </page-sub-header>
            <page-sub-header v-if="detailDateInfo">
              :{{ detailDateInfo?.date }}
            </page-sub-header>
            <v-spacer />
            <v-btn
              icon
              @click="showDetailInfo = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div v-if="!detailDateInfo">
            <v-tabs v-model="tab">
              <v-tab>
                {{ $t('date') }}
              </v-tab>
              <v-tab>
                {{ $t('ShiftHourlyRate') }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-data-table
                  :headers="dateHeader"
                  :items="currentStaffDetail"
                  class="elevation-0"
                  dense
                  item-key="name"
                  @click:row.self="showDetailDateInfo"
                />
              </v-tab-item>
              <v-tab-item>
                <v-card
                  v-if="currentStaffInfo"
                  class="px-4"
                  elevation="0"
                >
                  <div class="d-flex text-h4 font-weight-light">
                    <v-spacer />
                    {{ currentStaffInfo?.fromDate }} ~ {{ currentStaffInfo?.toDate }}
                  </div>
                  <div class="d-flex text-h4 font-weight-light">
                    {{ $t('totalTimeInHour') }}:{{ currentStaffInfo?.totalWorkHour }}
                    <v-spacer />
                    {{ $t('sumTotal') }}:{{ currentStaffInfo?.totalIncome | priceDisplay }}
                  </div>
                </v-card>

                <v-data-table
                  :headers="hourlyWageHeader"
                  :items="currentStaffInfo?.details"
                  class="elevation-0"
                  dense
                  item-key="name"
                  @click:row.self="showDetailDateInfo"
                />
              </v-tab-item>
            </v-tabs-items>
          </div>
          <div v-else>
            <div class="d-flex text-h4 font-weight-bold">
              <v-spacer />
              {{ $t('sumTotal') }}:{{ detailDateInfo.totalIncome | priceDisplay }}
            </div>
            <v-data-table
              :headers="detailHeader"
              :items="detailDateInfo.details"
              class="elevation-0"
              dense
              item-key="name"
            />
            <v-btn
              class="primary mt-4"
              width="100%"
              @click="back"
            >
              {{ $t('ToReturn') }}
            </v-btn>
          </div>
        </loading-provider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import NewServantRecords, {
  downloadClockInExcel,
  getStaffDetail
} from '@/model/dataLayer/api/tableAndPerson/NewServantRecords'
import PageSubHeader from '@/views/widget/typography/PageSubHeader.vue'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'
import { getRootUrl } from '@/model/global/GlobalSettings'
import i18n from '@/i18n'

export default {
  components: {
    LoadingProvider,
    PageSubHeader,
    IkDataTable
  },
  data () {
    return {
      tab: null,
      dialogLoading: false,
      currentHourlyData: null,
      hourlyWageHeader: [{ text: i18n.t('ShiftHourlyRate'), value: 'currentHourlyWage' }, { text: i18n.t('workHour'), value: 'workHour' }, { text: i18n.t('Revenue'), value: 'income' }],
      dateHeader: [{ text: i18n.t('date'), value: 'date' }, { text: i18n.t('avgHourlyWage'), value: 'avgHourlyWage' }, { text: i18n.t('totalTimeInHour'), value: 'totalWorkHour' }, { text: i18n.t('sumTotal'), value: 'totalIncome' }],
      detailHeader: [{ text: i18n.t('fromTime'), value: 'fromTime' }, { text: i18n.t('toTime'), value: 'toTime' }, { text: i18n.t('ShiftHourlyRate'), value: 'currentHourlyWage' }, { text: i18n.t('workHour'), value: 'workHour' }, { text: i18n.t('Revenue'), value: 'income' }],
      detailDateInfo: null,
      currentStaffDetail: [],
      currentStaffInfo: null,
      showDetailInfo: false,
      model: NewServantRecords
    }
  },
  watch: {
    showDetailInfo (val) {
      if (!val) {
        this.detailDateInfo = null
        this.currentStaffDetail = []
      }
    },
    '$parent.dateRange': {
      handler: function (val) {

      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async downloadExcel () {
      const res = await downloadClockInExcel(this.$parent.dateRange)
      window.open(getRootUrl() + 'Resource/' + res)
    },
    back () {
      this.detailDateInfo = null
    },
    showDetailDateInfo (item) {
      this.detailDateInfo = item
    },
    async goto (item) {
      this.showDetailInfo = true
      this.dialogLoading = true
      this.currentStaffDetail = (await getStaffDetail(this.$parent.dateRange, item.servantId)).sort((a, b) => new Date(b.date) - new Date(a.date))
      this.currentStaffInfo = item
      this.dialogLoading = false
    }
  }
}
</script>

<style scoped>

</style>
